export default __webpack_public_path__ + "static/epilogue-15ab4c501df88133a612ac54d8b3ca06.svg";